import { CurrencyData } from './currency';
import { Counts, Error, MainStatus } from './data';

export class Country {
  success: true|false;
  error: Error;
  results: string;
  counts: Counts;
  data: CountryData[] = [];
}

export class OneCountry {
  success: true|false;
  error: Error;
  results: string;
  data: CountryData;
}

export class CountryData {
    ref: number;
    title: string;
    iso: string;
    currency: CurrencyData;
    online: boolean;
    status: MainStatus;
    areas: Areas[] = [];
    created: string;
    lastModified: string;

    constructor() {
        this.currency = new CurrencyData();
        this.status = new MainStatus();
    }
}

export class CountryMiniData {
    ref: number;
    title: string;
    iso: string;
    currency: CurrencyData;
    online: boolean;

    constructor() {
        this.currency = new CurrencyData();
    }
}

export class Areas {
    ref: number;
    state: string;
}